<template>
  <el-table-column
    prop="partner_name"
    label="Partner"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <strong>#{{ scope.row.partner_id }}</strong> {{ scope.row.partner_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'partner_name',
};
</script>
